export default __webpack_public_path__ + "static/media/login-banner.4eedffc3.png";